import { render, staticRenderFns } from "./QNotificationMenu.vue?vue&type=template&id=557127cb&scoped=true&"
import script from "./QNotificationMenu.vue?vue&type=script&lang=js&"
export * from "./QNotificationMenu.vue?vue&type=script&lang=js&"
import style0 from "./QNotificationMenu.vue?vue&type=style&index=0&id=557127cb&prod&lang=scss&"
import style1 from "./QNotificationMenu.vue?vue&type=style&index=1&id=557127cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557127cb",
  null
  
)

export default component.exports